import { useContext } from "react";
import { IRealtimeContext, RealtimeContext } from "src/contexts";

function useRealtime(): IRealtimeContext {
    return useContext(RealtimeContext);
};

export default useRealtime;
